module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Media/Media-library#1-28335d9283d357673b80c7627c5f4b85.svg";